import { render, staticRenderFns } from "./CourseJoin.html?vue&type=template&id=21aed384&external"
import script from "./CourseJoin.ts?vue&type=script&lang=ts&external"
export * from "./CourseJoin.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports